<script setup lang="ts">
import {ref} from "vue";

interface Option {
    name: string,
    documentId: string,
}

const modelValue = defineModel('modelValue')

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    icon: {
        type: String,
    },
    options: {
        type: Array as PropType<Option[]>,
        required: true,
    },
    btn_class: {
        type: String,
        default: null
    },
    optionLabel: {
        type: String,
        default: 'name'
    },
    optionValue: {
        type: String,
        default: 'documentId'
    },
})

const selectedOptions = ref<(string|number)[]>([])
function handleChange(option: Option) {
    if(selectedOptions.value.some(item => item == option[props.optionValue])) {
        selectedOptions.value = selectedOptions.value.filter(item => item != option[props.optionValue])
    } else {
        selectedOptions.value.push(option[props.optionValue])
    }
    modelValue.value = selectedOptions.value
}

onMounted(() => {
    selectedOptions.value = modelValue.value
})
</script>

<template>
    <div>
        <p class="text-2xl font-bold mb-2">{{label}}</p>
        <div class="flex flex-wrap gap-2">
            <UiButton
                v-for="option in options"
                variant="lighter"
                size="sm"
                @click="handleChange(option)"
                class="text-black font-normal gap-1">
                <span>{{option[optionLabel]}}</span>
                <Icon v-if="selectedOptions.includes(option[optionValue])" name="ri:check-line" />
            </UiButton>
        </div>
    </div>
</template>